<template>
  <v-container fluid align-start ma-0 pa-2 class="epms2010-main container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" 
          :useBtnList="useBtnList"
          :unUseBtnList="unUseBtnList"
          @btnPorSheet="btnPorSheet" @btnBomList="btnBomList" @btnReceiptRequest="btnReceiptRequest" @btnPrintRequest="btnPrintRequest" 
          @btnPrintRequestVn="btnPrintRequestVn" @btnMakePI="btnMakePI" @btnRequestList="btnRequestList" @btnPipeListSaveAsExcel="btnPipeListSaveAsExcel"
          :key="useBtnListKey"
        >
          <template v-slot:body>
            <v-row no-gutters>
              <v-col cols="12" class="px-1">
                <i-label :label="'Basic Information : '"/>
              </v-col>
            </v-row>

            <v-row dense class="form-layout">
              <v-col cols="12" class="pa-0">
                <v-row no-gutters>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Quotation No</span>
                  </v-col>
                  <v-col cols="3">
                    <v-row no-gutters class="row__select-no">
                      <v-col cols="6">
                        <v-select
                          v-model="selectedQuot"
                          :items="quotList"
                          item-value="quotNo"
                          item-text="quotNo"
                          label="Select No"
                          return-object
                          single-line
                          outlined
                          dense
                          @change="quotNoChange"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Title</span>
                  </v-col>
                  <v-col cols="7">
                    <v-text-field 
                      v-model="headerData.quotTitle" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Ship No, POR No</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.shipPorNo" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Start Date</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.startDte" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Finish Time</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.finishDte" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Delivery Condition</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.transCondDesc" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Payment Condition</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.payCondDesc" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Purchase Charger</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.buyerName" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                </v-row>
                <!-- 수정 -->
                <v-row no-gutters>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Recieve Date</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.receiveDte" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Submit Date</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.submitDte" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Target Amount</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.piAmount" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="3" class="px-1">
                <i-label :label="'Detail Information : '"/>
              </v-col>
              <v-col cols="9" align="right" class="pa-1"  :style="headerData.receiveYn === 'Y' ? 'display: none;' : '' ">
                <span class="pa-1 subTitle2">[Not yet Received]</span>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" class="pt-1">
                <DxDataGrid id="epms2010" 
                  class="hipGridHeight5" 
                  :ref="epms2010Ref"
                  :data-source="dataList" 
                  :remote-operations="false" 
                  :hover-state-enabled="true"
                  :allow-column-resizing="true" 
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true" 
                  :show-borders="true" 
                  :width="grid.width"
                  :show-row-lines="true" 
                  key-expr="id" 
                  :focused-row-enabled="true"
                  :column-hiding-enabled="false" 
                  :selection="{ mode: 'none' }"
                  @cellPrepared="cellPrepared"
                >
                  <DxEditing :use-icons="true" />
                  <DxColumn data-field="id" caption="No" width="5%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="shipNo" caption="Ship No" width="7%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="porNo" caption="Por No" width="10%" data-type="string" alignment="center" cell-template="porNoTemplate" :allow-editing="false" />
                  <template #porNoTemplate="{ data }">
                    <v-btn small elevation="0" color="transparent" class="px-1 py-0 grd-btn"  @click.stop="drawingPage()">
                      {{ data.value }}
                    </v-btn>
                  </template>
                  <DxColumn data-field="matlCd" caption="Material Code" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="matlSpec" caption="Material Specition" width="35%" data-type="string" alignment="left" :allow-editing="false" />
                  <DxColumn data-field="matlUnit" caption="Unit" width="7%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="reqQty" caption="Quantity" width="10%" data-type="number" format="#,##0" alignment="right" :allow-editing="false" />
                  <DxColumn data-field="whReqDte" width="10%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="dateTemplate"  />
                  <template #dateTemplate>
                    <div>Request<br>Delivery Date</div>
                  </template>
                  <DxColumn data-field="certYn" width="5%" data-type="string" alignment="center" header-cell-template="certTemplate" :allow-editing="false" />
                  <template #certTemplate>
                    <div>Cert<br>Y/N</div>
                  </template>
                </DxDataGrid>

                <div :style="headerData.filePath ? '' : 'display:none;' ">
                  <v-icon color="blue">$folder</v-icon><span class="pl-1 drawing" >View Attached File</span>
                </div>
                <div :style="dwgCount > 0 ? '' : 'display:none;' ">
                  <!-- <v-icon color="blue">$folder</v-icon><span class="pl-1 drawing" @click="drawingPage">View Drawing Page</span> -->
                  <v-icon color="blue">$folder</v-icon><span class="pl-1 drawing" @click="drawingPageQuot">View Drawing Page</span>
                </div>
              </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>

    <!-- <drawingPagePop v-if="showPop" :showPop.sync="showPop" :gbn="'POR'" :paramNo="dwgPorNo" /> -->
    <drawingPagePop v-if="showPop" :showPop.sync="showPop" :gbn="strGbn" :paramNo="dwgPorNo" />
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import notify from 'devextreme/ui/notify'
import drawingPagePop from '@/views/hip/common/drawingPagePop'
import { getDwgCountByQuot, getQuotNoList, getRequestHead, getRequestDetail, goReceive, reportView, getPipeQuotYn } from '@/api/view/hip/common/common'
import { getNumComma } from '@/utils/common.js'
import { epms7010xls } from '@/api/view/hip/common/commonXls'

export default {
  name: 'epms2010',
  mixins: [baseview, BaseDataGrid],
  components: {
    drawingPagePop
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      epms2010Ref: 'epms2010Ref',
      showPop: false,
      selectedQuot: null,
      quotList: [],
      dataList: [],
      headerData: {
        receiveYn: 'N',
        submitYn: 'N',
        piAmount: 0
      },
      dwgCount: 0,
      useBtnListKey: 0,
      unUseBtnList: [],
      useBtnList: ['btnPorSheet', 'btnBomList', 'btnReceiptRequest', 'btnPrintRequest', 'btnPrintRequestVn', 'btnMakePI', 'btnRequestList', 'btnPipeListSaveAsExcel'],
      useBtnListTemp: ['btnPorSheet', 'btnBomList', 'btnReceiptRequest', 'btnPrintRequest', 'btnPrintRequestVn', 'btnMakePI', 'btnRequestList', 'btnPipeListSaveAsExcel'],
      dwgPorNo: '',
      strGbn:''
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epms1010Ref)
    },
  },
  methods: {
    initData() {
      this.dataList = []
      this.headerData = {
        receiveYn: 'N',
        submitYn: 'N',
        piAmount: 0
      }
      this.dwgCount = 0,
      this.useBtnList = []
      this.unUseBtnList = []
      this.dwgPorNo = ''
    },
    async getQuotNoList() {
      const param = {
        makerCd: this.$store.state.user.makerCd,
        quotStep: 'B',
        userId: this.$store.state.user.userId,
        quotDiv: '',
      }

      await getQuotNoList(param).then(res => {
        // console.log('res', res)
        
        const setVal = res.list.find(element => element.quotNo === this.$route.params.quotNo)

        this.quotList = res.list
        this.selectedQuot = setVal
        this.quotNoChange(setVal)
      })
    },
    quotNoChange(e) {
      // console.log('e', e)
      // console.log('this.quotList', this.quotList)

      if(e) {
        this.getQuotData()
      }
    },
    async getQuotData() {
      try {
        this.initData()
        this.openLoading('searching')

        const param = {
          quotNo: this.selectedQuot.quotNo,
          quotStep: this.selectedQuot.quotStep,
          makerCd: this.$store.state.user.makerCd,
          quotDiv: ''
        }

        await getRequestHead(param).then(res => {
          // console.log('headRes', res)

          let data = res.list

          if(data.length > 0) {
            data[0].piAmount = this.getNumComma(data[0].piAmount)

            this.headerData = data[0]
          }
        })

        await getRequestDetail(param).then(res => {
          // console.log('detailRes', res)

          this.dataList = res.list
        })

        await getPipeQuotYn(param).then(res => {
          // console.log('pipeRes', res)

          if(res.list.length > 0) {
            this.headerData.pipeYn = res.list[0].yn
          }
        })

        await getDwgCountByQuot(param).then(res => {
          // console.log('dwgCountRes', res)
          this.dwgCount = res.list[0].tcnt
        })

        this.setBtnList()
      } finally {
        this.endLoading()
      }
    },
    setBtnList() {
      let btnTemp = this.$_.cloneDeep(this.useBtnListTemp)

      // console.log('btnTemp', btnTemp)
      // console.log('this.headerData', this.headerData)

      if(this.headerData.receiveYn === 'Y') {
        this.unUseBtnList.push('btnReceiptRequest')
      }

      if(this.headerData.pipeYn !== 'Y') {
        btnTemp = this.$_.filter(btnTemp, function(btnTemp) {
          return btnTemp !== 'btnPipeListSaveAsExcel'
        })
      }

      this.useBtnList = btnTemp
      this.useBtnListKey++
    },
    drawingPage(){
      const arrPor = this.headerData.shipPorNo.split(', ')
      let porNo = ''
      if(arrPor.length > 1) {
        porNo = arrPor[1].substr(0, 8)
      }

      this.dwgPorNo = porNo

      // console.log('this.dwgPorNo', this.dwgPorNo)

      this.showPop = true
    },

    drawingPageQuot(){
      
      this.dwgPorNo = this.headerData.quotNo
      
      this.strGbn = 'QUOT'
      this.showPop = true
    },

    getNumComma(val) {
      return getNumComma(val)
    },
    btnPorSheet() {
      if(!this.selectedQuot || !this.selectedQuot.quotNo) {
        this.vToastify(this.$t('There is no information for print.'), 'warn')
        return
      }
      const param = {
        fileName: 'por_sheet.jrxml',
        as_quot_no: this.selectedQuot.quotNo,
      }

      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnBomList() {
      if(!this.selectedQuot || !this.selectedQuot.quotNo) {
        this.vToastify(this.$t('There is no information for print.'), 'warn')
        return
      }
      const param = {
        fileName: 'bom_list.jrxml',
        as_quot_no: this.selectedQuot.quotNo,
      }
      
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnReceiptRequest() {
      if(this.headerData.receiveYn && this.headerData.receiveYn === 'Y') {
        return
      }

      if(!this.selectedQuot || !this.selectedQuot.quotNo) {
        this.vToastify(this.$t('There is no data for receive the P/I Request.'), 'warn')
        return
      }

      this.vToastifyPrompt(
        this.$t('Do you want to receive the P/I Request?'),
        'info',
        current => {
          this.openLoading('searching')

          const param = {
            quotNo: this.selectedQuot.quotNo,
            makerCd: this.$store.state.user.makerCd
          }

          // console.log('param', param)

          goReceive(param).then(res => {
            // console.log('res', res)

            const msg = res.body
            if(msg === 'OK') {
              notify(this.$t('Receipt P/I Quotation is completed.'), 'success', 3000)
              
              this.quotNoChange(this.selectedQuot)
            } else {
              this.vToastify(this.$t(msg), 'warn')
            }
          }).catch(error => {
            this.vToastify(error, 'warn')
          }).finally(() => {
            this.endLoading()
          })
        },
        null,
        true
      )
    },
    btnPrintRequest() {
      if(!this.selectedQuot || !this.selectedQuot.quotNo) {
        this.vToastify(this.$t('There is no Information for print.'), 'warn')
        return
      }

      const param = {
        fileName: 'epms2010.jrxml',
        as_quot_no: this.selectedQuot.quotNo,
        as_maker_cd: this.$store.state.user.makerCd
      }
      
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnPrintRequestVn() {
      if(!this.selectedQuot || !this.selectedQuot.quotNo) {
        this.vToastify(this.$t('There is no Information for print.'), 'warn')
        return
      }

      const param = {
        fileName: 'epms2010vn.jrxml',
        as_quot_no: this.selectedQuot.quotNo,
        as_maker_cd: this.$store.state.user.makerCd
      }
      
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnMakePI() {
      if(!this.selectedQuot || !this.selectedQuot.quotNo) {
        this.vToastify(this.$t('There is no data for make P/I.'), 'warn')
        return
      }

      if(this.headerData.receiveYn && this.headerData.receiveYn !== 'Y') {
        this.vToastify(this.$t('Not yet Received.'), 'warn')
        return
      }

      let dir_menu;

      if(this.selectedQuot.quotNo.includes('QL')){
        dir_menu = 'epms2030';
      }else if(this.selectedQuot.quotNo.includes('QO')){
        dir_menu = 'epms2040';
      }else if (this.selectedQuot.quotNo.includes('WM')){
        dir_menu = 'epms2020_waste';
      }else{
        dir_menu = 'epms2020';
      }

      this.$router.push({
        name: dir_menu,
        params: {
          quotNo: this.selectedQuot.quotNo
        }
      })
    },
    btnRequestList() {
      this.$router.push({
        name: 'epms2000'
      })
    },
    btnPipeListSaveAsExcel() {
      if(!this.selectedQuot || !this.selectedQuot.quotNo) {
        this.vToastify(this.$t('Quotation number is not selected.'), 'warn')
        return
      }

      const param = {
        quotNo: this.selectedQuot.quotNo,
        makerCd: this.$store.state.user.makerCd,//this.headerData.makerCd,
        quotStep: this.headerData.quotStep
      }

      epms7010xls(param)
    },
    cellPrepared(e){
      if(e.rowType === 'data'){
        e.cellElement.style.padding = '1px 8px'
      }
    }
  },
  mounted() {
    this.getQuotNoList()
  }
}
</script>

<style lang="scss" scoped>
$redBtn: #FF0000;
$blueBtn: #0000FF;

.form-layout::v-deep .col {
  border-width: 1px 0 0 1px;
  border-style: solid;
  border-color: gray;
  
  * {
    border: 0px none !important;
  }

  .row:not(.row__select-no) {
    border-width: 0 0 1px 0 !important;
    border-style: solid !important;
    border-color: gray !important;
  }

  .col:not(.quotNo) {
    border-width: 0 1px 0 0 !important;
    border-style: solid !important;
    border-color: gray !important;
  }
}
 .formHeader {
   background-color: rgb(223, 227, 213);
   font-weight: bold;
   color: black;
   font-size: 9pt;
 }
.subTitle {
  font-weight: bold;
  color: black;
}
.subTitle2 {
  font-weight: bold;
  color: red;
}
.quotNo {
  font-weight: bold;
  border: 1px solid gray;
  border-bottom: 0px;
  color: #0000FF;
  font-size: 9pt;
}
.drawing {
  font-size: 10pt;
  color: black;
  cursor: pointer;
}
.drawing:hover{
  color: #4980BC;
}
.grd-btn {
  text-transform: unset !important;
  font-weight: bold;

  :hover  {
    color: #4980BC;
  }
}

::v-deep {
  [role=btnReceiptRequest] {
    :not([disabled=disabled]) {
      .v-btn__content {
        div, i {
          color: #{$redBtn} !important;
        }
      }
    }
  }
}

::v-deep {
  [role=btnPrintRequest], [role=btnPrintRequestVn] {
    .v-btn__content {
      div, i {
        color: #{$blueBtn} !important;
      }
    }
  }
}
</style>